const clampUnitInterval = (value, fallback = 0.5) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return fallback;
  return Math.min(Math.max(numeric, 0), 1);
};

export const getMessagePlaceholderSeed = (message, fallback = 0.5) => {
  // Placeholder rows already carry skeleton/zombie seed values; just clamp for safety.
  return clampUnitInterval(message?.skeleton_seed ?? message?.zombie_seed ?? fallback, fallback);
};

const hashStringToUnitInterval = (value) => {
  // String seed -> stable 0..1 value, so widths stay fixed while a row is mounted.
  const text = String(value ?? '');
  let hash = 2166136261;
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return clampUnitInterval((hash >>> 0) / 4294967295, 0);
};

const resolveSeedToUnitInterval = (seed, key = 'default') => {
  if (typeof seed === 'number') return clampUnitInterval(seed);
  if (seed !== null && seed !== undefined && seed !== '') return hashStringToUnitInterval(`${seed}:${key}`);
  return 0.5;
};

export const seededSkeletonWidth = ({ seed, key = 'default', min, max }) => {
  const minWidth = Number(min);
  const maxWidth = Number(max);
  if (!Number.isFinite(minWidth) || !Number.isFinite(maxWidth)) return 0;
  if (maxWidth <= minWidth) return Math.round(minWidth);

  const unit = resolveSeedToUnitInterval(seed, key);
  return Math.round(minWidth + unit * (maxWidth - minWidth));
};
